import { BluLoader } from "@bludata/components";
import { memo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../store";

export const StudioFormLoader = memo(() => {
  const { studioFormLoader } = useSelector(
    (state: RootState) => state.studiForm
  );

  return (
    <BluLoader
      open={studioFormLoader}
      zIndex={400}
      sx={{ zIndex: 400 }}
      CircularProps={{
        sx: { zIndex: 400 },
      }}
    />
  );
});
